import { ClickAwayListener, Grow } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import * as React from 'react';
import styled from 'styled-components';
import { DSButtonGroup, DSMenuItem, DSMenuList, DSPaper, DSPopper } from '../../../mui';
import { DSButton } from '../DSButton';
import { DSLoaderButtonProps, DSLoaderButton } from '../DSLoaderButton';

const StyledDSButtonGroup = styled(DSButtonGroup)`
    background-color: white;
    button:first-child {
        color: black;
    }
`;

interface SplitButtonOptionType {
    label: string;
    onClick: () => void;
    style?: React.CSSProperties;
}

export interface SplitButtonProps extends Pick<DSLoaderButtonProps, 'children' | 'color' | 'loading'> {
    onClick?: () => void;
    options?: SplitButtonOptionType[];
}

export const SplitButton: React.FC<SplitButtonProps> = ({
    color = 'primary',
    loading = false,
    onClick,
    options,
    ...buttonProps
}) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLDivElement>(null);

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    const handleClose = (event: React.MouseEvent<Document>) => {
        if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
            return;
        }

        setOpen(false);
    };

    return (
        <>
            <StyledDSButtonGroup innerRef={anchorRef} variant="outlined">
                <DSLoaderButton
                    color={color}
                    loading={loading}
                    onClick={() => {
                        setOpen(false);
                        onClick?.();
                    }}
                    {...buttonProps}
                />
                {options && (
                    <DSButton aria-label="More" color={color} disabled={loading} size="small" onClick={handleToggle}>
                        <ArrowDropDownIcon />
                    </DSButton>
                )}
            </StyledDSButtonGroup>
            {options && (
                <DSPopper anchorEl={anchorRef.current} disablePortal open={open} placement="top" transition>
                    {({ placement, TransitionProps }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                            }}
                        >
                            <DSPaper
                                style={{
                                    minWidth: anchorRef.current ? anchorRef.current.offsetWidth - 2 : undefined,
                                }}
                            >
                                <ClickAwayListener onClickAway={handleClose}>
                                    <DSMenuList>
                                        {options.map(option => (
                                            <DSMenuItem
                                                key={option.label}
                                                style={option.style}
                                                onClick={() => {
                                                    setOpen(false);
                                                    option.onClick();
                                                }}
                                            >
                                                {option.label}
                                            </DSMenuItem>
                                        ))}
                                    </DSMenuList>
                                </ClickAwayListener>
                            </DSPaper>
                        </Grow>
                    )}
                </DSPopper>
            )}
        </>
    );
};
SplitButton.displayName = 'SplitButton';
